import { ICompanyAccess } from "../../types/companyaccess.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = `${import.meta.env.VITE_API_URL}/companyaccess`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function loadCompanyAccesses(email: string | undefined) {
  const url = `${API_URL}/email/${email}`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<ICompanyAccess>
  >;

  return result;
}
export async function updateCompanyAccess(
  email: string,
  companyIds: string[],
  viewAll: boolean
): Promise<ApiResponseType<ICompanyAccess>> {
  const url = `${API_URL}/email/${email}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ companyIds, viewAll }),
  };

  const result = (await makeRequest(url, options)) as unknown as Promise<
    ApiResponseType<ICompanyAccess>
  >;

  return result;
}
export async function companyAccessesById(
  companyId: string | undefined
): Promise<ApiResponseType<ICompanyAccess>> {
  const url = `${API_URL}/id/${companyId}`;
  const result = (await makeRequestDebounced(
    url
  )) as ApiResponseType<ICompanyAccess>;
  return result;
}

export const getCompanyAccess = () => {
  const companyAccess = localStorage.getItem("companyaccess");
  return companyAccess;
};
